<template>
    <button v-bind="$attrs" v-on="$listeners" :disabled="disabled || loading">
        <loader v-if="loading" size="small" />
        <slot v-else></slot>
    </button>
</template>

<script>
import Loader from '@/tools/loaders/loader1'

export default {
    inheritAttrs: false,
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Loader,
    }
}
</script>



// WEBPACK FOOTER //
// LoadingButton.vue?6d32c424